export default "skymp5-front/061c8068a2aabac97b3c03046b3048e2.gif";